import React from "react"
import "./actions.sass"
import IconDown from "../../images/partner/icon-down@2x.png"
import Button from "../../components/button"
import { showForm } from "../../components/forms"
import { defaultIntl } from "../../utils"
import { applyTypes } from "../../components/forms/form"
import { MERCHANT } from "../../../config"
export default ({ intl = defaultIntl }) => {
  return (
    <div className="partner-actions">
      <div className="banner--body">
        <div className="container">
          <div className="text-content">
            <h2>{intl.formatMessage({ id: "partner.actions.title" })}</h2>
            <p>{intl.formatMessage({ id: "partner.actions.desc" })}</p>
            <Button to={`${MERCHANT}/${intl.locale}/`}>{intl.formatMessage({ id: "partner.actions.btn1" })}</Button>
            <Button className="invert" to={['zh', 'en'].includes(intl.locale)?"/advertisement-handbook.pdf":"/advertisement-handbook-fr.pdf"} icon={IconDown}>
              {intl.formatMessage({ id: "partner.actions.btn2" })}
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
